import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Sidebar.css";

export default function Sidebar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const [openSidebar, setOpenSidebar] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState("");

  // Si aucun utilisateur connecté
  if (!user) return null;

  // Vérifie la page active
  const isActive = (path) => location.pathname === path;

  // Ouvre / ferme un sous-menu
  const toggleSubMenu = (menu) => {
    setOpenSubMenu((current) => (current === menu ? "" : menu));
  };

  // Ferme la sidebar mobile
  const closeSidebar = () => {
    setOpenSidebar(false);
  };

  // Ferme aussi le sous-menu lors d'une navigation
  const handleNavigation = () => {
    closeSidebar();
  };

  // Déconnexion
  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <>
      {/* ================================
          OVERLAY MOBILE
      ================================= */}
      {openSidebar && (
        <div
          className="sidebar-overlay"
          onClick={closeSidebar}
        />
      )}

      {/* ================================
          SIDEBAR
      ================================= */}
      <aside className={`sidebar ${openSidebar ? "open" : ""}`}>

        {/* HEADER */}
        <div className="sidebar-header">
          <div className="logo">
        <h3>Climatisation LS</h3>
      </div>
          <button
            type="button"
            className="close-btn"
            onClick={closeSidebar}
            aria-label="Fermer le menu"
          >
            ✖
          </button>
        </div>

        {/* MENU */}
        <ul className="sidebar-menu">

          {/* =================================
              MENU ADMIN
          ================================= */}
          {user.role === "ADMIN" && (
            <>
              {/* Dashboard */}
              <li className={isActive("/admin") ? "active" : ""}>
                <Link
                  to="/admin"
                  onClick={handleNavigation}
                >
                  🏠 <span>Dashboard</span>
                </Link>
              </li>

              {/* Clients */}
              <li className={isActive("/clients") ? "active" : ""}>
                <Link
                  to="/clients"
                  onClick={handleNavigation}
                >
                  👤 <span>Clients</span>
                </Link>
              </li>

              {/* Rendez-vous */}
              <li className={isActive("/rendez-vous") ? "active" : ""}>
                <Link
                  to="/rendez-vous"
                  onClick={handleNavigation}
                >
                  📅 <span>Rendez-vous</span>
                </Link>
              </li>

              {/* Finance */}
              <li className={isActive("/finance") ? "active" : ""}>
                <Link
                  to="/finance"
                  onClick={handleNavigation}
                >
                  💰 <span>Finance</span>
                </Link>
              </li>

              {/* Paiements */}
              <li className={isActive("/paiements") ? "active" : ""}>
                <Link
                  to="/paiements"
                  onClick={handleNavigation}
                >
                  💳 <span>Paiements</span>
                </Link>
              </li>

              {/* =================================
                  PARAMÈTRES
              ================================= */}
              <li
                className={`submenu-title ${
                  openSubMenu === "parametres" ? "submenu-open" : ""
                }`}
                onClick={() => toggleSubMenu("parametres")}
              >
                <span>⚙️ Paramètres</span>

                <span className="submenu-arrow">
                  {openSubMenu === "parametres" ? "▲" : "▼"}
                </span>
              </li>

              {/* Sous-menu paramètres */}
              {openSubMenu === "parametres" && (
                <ul className="submenu">

                  {/* Types entretien */}
                  <li
                    className={
                      isActive("/types-entretien") ? "active" : ""
                    }
                  >
                    <Link
                      to="/types-entretien"
                      onClick={handleNavigation}
                    >
                      🛠 <span>Types d'entretien</span>
                    </Link>
                  </li>

                  {/* Utilisateurs */}
                  <li
                    className={
                      isActive("/utilisateurs") ? "active" : ""
                    }
                  >
                    <Link
                      to="/utilisateurs"
                      onClick={handleNavigation}
                    >
                      👥 <span>Comptes</span>
                    </Link>
                  </li>

                  {/* Modes paiement */}
                  <li
                    className={isActive("/modes") ? "active" : ""}
                  >
                    <Link
                      to="/modes"
                      onClick={handleNavigation}
                    >
                      💵 <span>Modes</span>
                    </Link>
                  </li>

                </ul>
              )}
            </>
          )}

          {/* =================================
              MENU TECHNICIEN
          ================================= */}
          {user.role === "TECHNICIEN" && (
            <>
              {/* Dashboard technicien */}
              <li
                className={
                  isActive("/technicien") ? "active" : ""
                }
              >
                <Link
                  to="/technicien"
                  onClick={handleNavigation}
                >
                  🏠 <span>Dashboard</span>
                </Link>
              </li>

              {/* Mes rendez-vous */}
              <li
                className={
                  isActive("/technicien/mes-rendez-vous")
                    ? "active"
                    : ""
                }
              >
                <Link
                  to="/technicien/mes-rendez-vous"
                  onClick={handleNavigation}
                >
                  📅 <span>Mes rendez-vous</span>
                </Link>
              </li>
            </>
          )}

          {/* =================================
              DÉCONNEXION
          ================================= */}
          <li className="logout-container">
            <button
              type="button"
              className="btn-logout"
              onClick={handleLogout}
            >
              🚪 <span>Déconnexion</span>
            </button>
          </li>

        </ul>
      </aside>

      {/* ================================
          BOUTON BURGER
      ================================= */}
      <button
        type="button"
        className="burger-btn"
        onClick={() => setOpenSidebar(true)}
        aria-label="Ouvrir le menu"
      >
        ☰
      </button>
    </>
  );
}